module.exports = __webpack_public_path__ + "static/media/bg-room.39ef59fc.png";